var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader ease-linear rounded-full border-2 border-t-2 border-gray-200 h-5 w-5"})}
var staticRenderFns = []

export { render, staticRenderFns }